import { useState, useEffect } from 'react';
import { Trophy, Crown } from '@phosphor-icons/react';
import { fetchLeaderboard } from '../../lib/games';

export function Leaderboard({ game, refreshKey = 0 }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    let active = true;
    fetchLeaderboard(game)
      .then((d) => active && setData(d))
      .catch(() => active && setData(null));
    return () => { active = false; };
  }, [game, refreshKey]);

  if (!data) return null;

  return (
    <div className="border border-white/10 bg-black/40 rounded-lg p-4" data-testid="game-leaderboard">
      <div className="flex items-center justify-between mb-3">
        <span className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-amber-300">
          <Trophy size={16} weight="fill" /> Top 10
        </span>
        <span className="text-xs text-muted-foreground" data-testid="game-personal-best">
          Your best: <span className="text-white">{data.personal_best ?? '—'}</span>
        </span>
      </div>
      {data.top.length === 0 ? (
        <p className="text-xs text-muted-foreground">No scores yet. Be the first!</p>
      ) : (
        <ol className="space-y-1.5">
          {data.top.map((row) => (
            <li key={`${row.rank}-${row.username}`} className="flex items-center justify-between text-sm">
              <span className="flex items-center gap-2">
                <span className="w-5 text-xs text-muted-foreground">{row.rank}</span>
                {row.rank === 1 && <Crown size={14} weight="fill" className="text-amber-300" />}
                <span className="truncate max-w-[140px]">{row.username}</span>
              </span>
              <span className="tabular-nums">{row.score}</span>
            </li>
          ))}
        </ol>
      )}
      <p className="text-[11px] text-muted-foreground mt-3">
        {data.lower_is_better ? 'Lower score wins' : 'Higher score wins'}
      </p>
    </div>
  );
}
